
// const STATIC_GLUE_ID = "US-DE.N-DOC-19670731:660813";
// Cage code = 510f4
// uei zh4nvfg3z526

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CompanySummary from "./CompanySummary";
import LoadingSpinner from "../../utils/Loader/LoadingSpinner";
import { fetchSummaryByGlueId } from "../../api/getSummary";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const SummaryPage = () => {
    const { glue_id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [downloadOpen, setDownloadOpen] = useState(false);


    useEffect(() => {
        if (!glue_id) {
            setError("No glue_id provided.");
            setLoading(false);
            return;
        };

        const decodedId = decodeURIComponent(glue_id);

        setLoading(true);
        fetchSummaryByGlueId(decodedId)
            .then((data) => {
                setData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message || "API error");
                setLoading(false);
            });
    }, [glue_id]);

    return (
        <div className="page-container">
            <Header
                navigateTo="/glue-dashboard"
                headerName="Summary View"
                setDownloadOpen={setDownloadOpen}
            />

            <div className="page-content">
                {loading && <LoadingSpinner message="Loading company summary..." />}
                {error && <div style={{ color: 'red' }}>Error: {error}</div>}
                {!loading && !error && data && <CompanySummary data={data} downloadOpen={downloadOpen}/>}
            </div>

            <Footer />
        </div>
    );
};

export default SummaryPage;
